import {delegateEvent, showDesktopLanguages, showMobileLanguages} from "./common"
import "../scss/home.scss"

delegateEvent('click', ".js-language-menu", showDesktopLanguages, showMobileLanguages)